import { Component, EventEmitter, Output, Input } from '@angular/core';
import { Router } from '@angular/router';
import { CreditErrorType } from 'src/app/models/enums/credit-error.enum';
import { AppModules, CreditRequestRoutes } from 'src/app/models/enums/routes.enum';
import { DataService } from 'src/app/services/data.service';
import { ButtonComponent } from 'src/app/shared/reusable/button/button.component';

@Component({
  selector: 'app-first-loan-main-page',
  templateUrl: './first-loan-main-page.component.html',
  styleUrls: ['./first-loan-main-page.component.scss'],
  standalone: true,
  imports: [ButtonComponent],
})
export class FirstLoanMainPageComponent {
  static componentName = 'FirstLoanMainPageComponent';
  static componentDescription = 'Punto de entrada para solicitantes de primer préstamo con verificaciones de mantenimiento de plataforma';
  @Output() nextStep = new EventEmitter<boolean>();
  @Input() isModal = false;

  private isPlatformInMaintenance = this.dataService.isPlatformInMaintenance;
  constructor(private router: Router, private dataService: DataService) {}

  goToOnBoarding(): void {
    //Is modal means that the view is in the whitelist mode
    if (this.isPlatformInMaintenance() && !this.isModal) {
      this.router.navigate([AppModules.CREDIT_REQUEST, CreditRequestRoutes.ERROR, CreditErrorType.MAINTENANCE, '']);
    } else {
      if (this.isModal) this.nextStep.emit(true);
      else this.router.navigate([AppModules.CREDIT_REQUEST, CreditRequestRoutes.ONBOARDING_START]);
    }
  }
}
